import { Skeleton, CardContent, Card, Box, Avatar } from '@mui/material';

export default function ProfileCard() {
    return (
        <>
            <Box
                sx={{
                    height: '100%',
                    display: 'grid',
                }}
                >
                <Card 
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    }}
                    >
                    <Box 
                        alignItems="center"
                        justifyContent="center"
                        my="10%"
                        mx="auto"
                        >
                        <Skeleton
                            variant="square"
                            sx={{ width: 100,
                                height: 100,
                                margin: "auto", borderRadius:5 }} />
                        <CardContent>
                            <Skeleton animation="wave" height={30} style={{ marginBottom: 10, width: 170 }} sx={{mx: "auto", textAlign:"center"}}/>
                            <Skeleton animation="wave" height={20} style={{ marginBottom: 5, width: 120  }} sx={{mx: "auto", textAlign:"center"}}/>
                        </CardContent>
                    </Box>
                </Card>
            </Box>
        </>
    )
}